import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { salesWarehouseInventoryRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const salesWarehouseInventoryRouteMetadata: IRouteMetadataObj<
  typeof salesWarehouseInventoryRoutesObj
> = {
  list: {
    title: "warehouseManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/salesWarehouseInventory/table/page"),
    mode: "index",
    type: "main",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "warehouseManagement.centralWarehouseInventory.create.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/addNewItem/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "warehouseManagement.viewAndEditItem.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/addNewItem/editItem/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },

  warehouseExit: {
    title: "warehouseManagement.warehouseExit.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/warehouseExit/form/page"),
    mode: "create",
    type: "inner",
    icon: "SubtractLine",
    breadcrumbs: [],
    permission,
  },
  sendToScrapWarehouse: {
    title: "warehouseManagement.sendToScrapWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/sendToScrapWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "DeleteBin2Line",
    breadcrumbs: [],
    permission,
  },
  returnFromScrapWarehouse: {
    title: "warehouseManagement.returnFromScrapWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/returnFromScrapWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "RestartLine",
    breadcrumbs: [],
    permission,
  },
  transferToSalesWarehouse: {
    title: "warehouseManagement.transferToSalesWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/transferToSalesWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "ArrowLeftRightLine",
    breadcrumbs: [],
    permission,
  },
};

export const salesWarehouseInventoryRoutes = createRoute<
  typeof salesWarehouseInventoryRoutesObj
>(salesWarehouseInventoryRoutesObj, salesWarehouseInventoryRouteMetadata);
